export default "__VITE_ASSET__DQBfBXkj__"